import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { MetricsSection } from './components/MetricsSection';
import { AdPreviewShowcase } from './components/AdPreviewShowcase';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-200 selection:bg-emerald-500/30 selection:text-emerald-200 font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <MetricsSection data-id="element-4" />
        <AdPreviewShowcase data-id="element-5" />
        <Features data-id="element-6" />
        <Pricing data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}